module.exports = __webpack_public_path__ + "img/ic_origin_supplier.47d00a6c.png";